'use strict';


app.run(function ($rootScope, $http) {
  $rootScope.debugTools = $rootScope.debugTools || {};
  $rootScope.debugTools.resetUserGuides = function () {
    $http.delete('/api/v1/debug/deleteUserGuides').then(function () {
      location.reload();
    });
  };
});
